import { pipe, map, reduce, reverse, split, toPairs } from 'ramda';

export const toTwoDigitsNumber = (value: number) => (value <= 9 ? `0${value}` : String(value));

export const convertMMSSToSS = pipe(
  split(':'),
  reverse,
  toPairs,
  reduce((duration, [i, chunk]) => duration + Number(chunk) * Math.pow(60, Number(i)), 0),
);

export const convertISO8601ToMMSS = (durationStr) => {
  if (!durationStr) {
    return '00:00';
  }

  const [, ...parts] = durationStr.match(/^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
  const [days, hours, minutes, seconds] = map<string, number>((part) => Number(part) || 0, parts);
  const [hoursStr, minutesStr, secondsStr] = map<number, string>(toTwoDigitsNumber, [
    days * 24 + hours,
    minutes,
    seconds,
  ]);

  if (hoursStr === '00') {
    return `${minutesStr}:${secondsStr}`;
  }

  return `${hoursStr}:${minutesStr}:${secondsStr}`;
};

export const convertISO8601ToSS = pipe(convertISO8601ToMMSS, convertMMSSToSS);

export const convertMSSToMMSS = (durationMillisec = 0) => convertSSToMMSS(durationMillisec / 1000);

export const convertSSToMMSS = (durationSec) => {
  let parsedDurationSec = Math.floor(durationSec || 0);

  const chunks = [];
  do {
    chunks.unshift(toTwoDigitsNumber(parsedDurationSec % 60));

    parsedDurationSec = Math.floor(parsedDurationSec / 60);
  } while (parsedDurationSec > 0);

  if (chunks.length < 2) {
    chunks.unshift('00');
  }

  return chunks.join(':');
};
